import { createContext, RefObject } from 'react';

const Context = createContext<{
  containerRef: RefObject<HTMLDivElement>;
  onPositionChange: (x: number) => void;
}>({
  containerRef: { current: null },
  onPositionChange: () => null,
});

export default Context;
